module.exports = __webpack_public_path__ + "fonts/ProsciuttoSansish.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/ProsciuttoSansish.woff
// module id = 36
// module chunks = 0